export const DELETE_USER = 'speakeasy/Users/DELETE_USER';

export const SET_DELETE_ERROR = 'speakeasy/Users/SET_DELETE_ERROR';

export const CHANGE_PASSWORD = 'speakeasy/Users/CHANGE_PASSWORD';

export const SET_PASSWORD_ERROR = 'speakeasy/Users/SET_PASSWORD_ERROR';

export const SET_SUCCESS_SNACKBAR = 'speakeasy/Users/SET_SUCCESS_SNACKBAR';
